import moment from 'moment';
import { getWeekRange, getWeekDays } from '../../helpers';
import * as engineeringTypes from './types';

const initialState = {
  engineeringEntries: {
    data: [],
    isLoading: false,
    selectedDays: getWeekDays(getWeekRange(moment()).from),
    oid: null,
    error: null,
  },
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case engineeringTypes.GET_ENGINEERING_TIME_ENTRIES:
      return {
        ...state,
        engineeringEntries: {
          ...state.engineeringEntries,
          oid: action.oid || state.engineeringEntries.oid,
          selectedDays:
            action.selectedDays || state.engineeringEntries.selectedDays,
          isLoading:
            action.isLoading !== false || state.engineeringEntries.isLoading,
          error: null,
        },
      };

    case engineeringTypes.GET_ENGINEERING_TIME_ENTRIES_SUCCESS: {
      const sortedData = !state.engineeringEntries.hasInitiallyLoaded
        ? [...(action.payload || [])].sort(
            (a, b) => a.projectNumber - b.projectNumber
          )
        : action.payload || [];

      return {
        ...state,
        engineeringEntries: {
          ...state.engineeringEntries,
          data: sortedData,
          isLoading: false,
          error: null,
        },
      };
    }

    case engineeringTypes.GET_ENGINEERING_TIME_ENTRIES_ERROR:
      return {
        ...state,
        engineeringEntries: {
          ...state.engineeringEntries,
          data: [],
          isLoading: false,
          error: action.error || null,
        },
      };

    case engineeringTypes.UPSERT_ENGINEERING_TIME_ENTRY_SUCCESS:
      return {
        ...state,
        engineeringEntries: {
          ...state.engineeringEntries,
          data: state.engineeringEntries.data.map((engineeringEntry) => {
            if (engineeringEntry.projectId !== action.payload.projectId) {
              // No match, return as is
              return engineeringEntry;
            }

            return {
              ...engineeringEntry,
              entries: [
                ...engineeringEntry.entries.filter((entry) => {
                  return entry.id !== action.payload.timeEntry.id;
                }),
                action.payload.timeEntry,
              ],
            };
          }),
          error: null,
        },
      };
    case engineeringTypes.ADD_ENGINEERING_ENTRY:
      return {
        ...state,
        engineeringEntries: {
          ...state.engineeringEntries,
          data: [...state.engineeringEntries.data, action.payload],
          error: null,
        },
      };
    case engineeringTypes.DELETE_ENGINEERING_ENTRY: {
      return {
        ...state,
        engineeringEntries: {
          ...state.engineeringEntries,
          data: state.engineeringEntries.data.filter(
            (entry) => entry.projectId !== action.payload
          ),
          error: null,
        },
      };
    }

    default:
      return state;
  }
};
